import React, { Component } from 'react';

import './spinner.css';
import logo from '../../assets/img/bsm-logo-single-transparent.png';

class Spinner extends Component {
    render() {
        return (
            <div className="loading">
                {/*<div className="whirl duo" />*/}
                <img className="loading-logo" src={logo} alt="loading logo" />
            </div>
        );
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js